import { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function SEO({ title, description }) {
  const { lang } = useLanguage();

  useEffect(() => {
    const siteTitle = 'Massage with Jette';
    const finalTitle = title ? `${title} | ${siteTitle}` : 'Massage with Jette – Professionel massage i København';
    
    document.title = finalTitle;

    const defaultDesc = lang === 'da'
      ? 'Professionel massage i København med over 29 års erfaring. Individuelle behandlinger med fokus på balance, velvære og kroppens naturlige evne til at hele.'
      : 'Professional massage therapy in Copenhagen with over 29 years of experience. Tailored treatments focused on balance, well-being, and natural body healing.';

    const finalDesc = description || defaultDesc;

    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', finalDesc);
    } else {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      metaDesc.content = finalDesc;
      document.head.appendChild(metaDesc);
    }

    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', finalTitle);
    }

    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) {
      ogDesc.setAttribute('content', finalDesc);
    }

    document.documentElement.lang = lang;
  }, [title, description, lang]);

  return null;
}
